import { render } from "./uploadFiles.vue?vue&type=template&id=5143fe74&ts=true"
import script from "./uploadFiles.vue?vue&type=script&lang=ts"
export * from "./uploadFiles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__